import axiosInstance from "../axiosInstance";

export const getAllexperience = async () => {
  try {
    const data = await axiosInstance.get(
      "experience/?page=1&limit=10",
    );
    return data;
  } catch (error) {
    // console.log("Error logging in:", error);
  }
};

export const getExperience = async (experienceID: string) => {
  try {
    const data = await axiosInstance.get(
      `experience/${experienceID}`,
    );
    return data;
  } catch (error) {
    // console.log("Error logging in:", error);
  }
};

